import React from 'react';
import { Text, Flex, Image, VStack, AspectRatio, Heading, Box } from '@chakra-ui/react'

function Video ({ text }){

  var md = require('markdown-it')({ breaks: true });

  return(
    <Box>
      {/* PRIMERA FILA --> Panaacea*/}
      <Flex minH={['auto','auto','auto','120vh','100vh']} direction={['column','column','column','row']} pt={['20%','20%','10%','0%','0%']}>
        <VStack w='full' minH={['auto','auto','auto','full','full']} bg={['white','black']} justifyContent='center' py={['0%','0%','5%','2%','2%']}>
            <Image src={require('./data/assets/Panaacea/panaacea.jpg')} boxSize={['80%','88%']} objectFit='contain'/>
        </VStack>
        <VStack  w='full' minH={['auto','auto','auto','full','full']} bg='white' justifyContent='center' py={['0%','0%','10%','5%','5%']}> 
          <VStack alignItems='center'  w={['100%','100%','80%','60%','60%']} textAlign='center' >
            <Heading fontWeight={'900'} pb={8}>{text.panaacea.tit}</Heading>
            <Text dangerouslySetInnerHTML={ { __html: md.render(text.panaacea.desc)} } pb={['10%','5%']} px={['3%','0%']}></Text>

            <AspectRatio w={['80%','90%']} ratio={16/9}>
              <iframe
                  title='Panaacea'
                  src="https://www.youtube.com/embed/0uiJO9PW6-k"
                  allowFullScreen
              />
            </AspectRatio>
          </VStack>
        </VStack>
      </Flex>
      
      {/* SEGUNDA FILA */}
      <Flex minH={['auto','auto','auto','130vh','100vh']} direction={['column-reverse','column-reverse','column-reverse','row']} pt={['20%','20%','5%','0%','0%']} >
        <VStack w='full' minH='full' bg={['black','white']} py={['10%','10%','5%','2%','2%']}>
          <VStack alignItems='center' textAlign='center' w={['100%','524px']} pb={['20%','20%','5%','5%','0%']}>
            <Heading color={['white','black']} fontWeight={'900'} pt={['10%',28]}> {text.elOrden.tit}  </Heading>
            <Text color={['white','black']} pt={8} pb={20} px={['3%','0%']} dangerouslySetInnerHTML={ { __html: md.render(text.elOrden.desc)} }></Text>
            <AspectRatio w={['80%','100%']} ratio={16/9}>
              <iframe
                title='El orden natural de las cosas'
                src="https://www.youtube.com/embed/dtrYvqrb5Xw"
                allowFullScreen
                />
            </AspectRatio>
          </VStack>
        </VStack>
        <VStack  w='full' minH='full' bg='black' justifyContent='center' py={['10%','10%','10%','2%','2%']}> 
          <Box w={['80%','95%']} pl={['0%','10%']}>              
            <Image src={require('./data/assets/Temp/temp.jpg')} boxSize={['100%','88%']} />
          </Box>
        </VStack>
      </Flex>

      {/* TERCERA FILA */}
      <Flex minH={['auto','auto','auto','150vh','100vh']} direction={['column','column','column','row']}>
        <VStack w='full' minH='full' bg={['white','black']} justifyContent='center' py={['10%','10%','10%','2%','2%']}>
            <Image src='img/adventure-time.jpg' boxSize={['80%','88%']} objectFit='contain' />
        </VStack>
        <VStack  w='full' minH='full' bg='white' justifyContent='center' py={['0%','0%','10%','2%','2%']} px={['2%','2%','0%','0%','0%']}> 
          <VStack alignItems='center'  w={['100%','100%','80%','60%','60%']}  textAlign='center' >
            <Heading fontWeight={'900'}>Adventure Time:</Heading>
            <Heading fontWeight={'900'} pb={8}>Aventuras en el mundo de Ooo</Heading>
            {/* <Heading fontWeight={'900'} pb={8} >Aventuras en el mundo de Ooo</Heading> */}
            <Text px={['3%','0%']} dangerouslySetInnerHTML={{ __html: md.render(text.adventureTime.desc[0] )}}></Text>
            <br/>
            <Text pb='20' px={['3%','0%']} dangerouslySetInnerHTML={{ __html: md.render(text.adventureTime.desc[1] )}}></Text>
            <AspectRatio w={['80%','100%']} ratio={16/9}>
              <iframe
                  title='Adventure Time'
                  src='https://www.youtube.com/embed/glECGKPyBfQ'
                  allowFullScreen
              />
            </AspectRatio>     
          </VStack>
        </VStack>
      </Flex>   

      {/* CUARTA FILA */}
      <Flex minH={['auto','auto','auto','130vh','100vh']} direction={['column','column','column-reverse','row']} pt={['20%','20%','5%','0%']}>
        <VStack w='full' minH='full' bg={['black','white']} py={['0%','0%','0%','2%','2%']}>
          <VStack alignItems='center' textAlign='center' w={['100%','60%']}>
            <Heading color={['white','black']} fontWeight={'900'} pt={['20%',28]}> {text.trenes.tit}  </Heading>
            <Text color={['white','black']} pt={8} pb={20} px={['3%','0%']} dangerouslySetInnerHTML={ { __html: md.render(text.trenes.desc)} }></Text>
            <AspectRatio w={['80%','100%']} ratio={16/9}>
              <iframe
                title='Trenes'
                src="https://www.youtube.com/embed/q5A_elA5N8Y"
                allowFullScreen
                />
            </AspectRatio>
          </VStack>
        </VStack>
        <VStack w='full' minH='full' bg='black' justifyContent='center' py={['10%','10%','10%','2%','2%']}>             
            <AspectRatio w={['80%','85%']} ratio={16/9}>
              <iframe
                title='Mi Barco'
                src="https://www.youtube.com/embed/Kd7PsWw6WUM"
                allowFullScreen
                />
            </AspectRatio>
        </VStack>
      </Flex>    

      {/* QUINTA FILA */}
      <Flex minH={['auto','auto','auto','120vh','100vh']} direction={['column','column','column','row']} pt={['20%','20%','8%','0%']} pb={['20%','20%','0%','0%','0%']}>
        <VStack w='full' minH={['40%','full']} bg={['white','black']} justifyContent='center' py={['0%','0%','10%','2%','2%']}>
            <Image src={require('./data/assets/TengoSed/tengoSed.png')} boxSize={['80%','88%']} objectFit='contain' />
        </VStack>
        <VStack  w='full' minH='full' bg='white' justifyContent='center' py={['0%','0%','10%','2%','2%']}> 
          <VStack alignItems='center'  w={['100%','100%','80%','60%','60%']}   textAlign='center' >
            <Heading fontWeight={'900'}>{ text.tengoSed.tit }</Heading>
            <Text py={['10%','4%']} px={['3%','0%']} dangerouslySetInnerHTML={{ __html: md.render(text.tengoSed.desc) }}></Text>
                       
            <AspectRatio w={['80%','100%']} ratio={16/9}>
              <iframe
                  title='Tengo sed'
                  src="https://www.youtube.com/embed/om-8JLkALXY"
                  allowFullScreen
              />
            </AspectRatio>     
          </VStack>
        </VStack>
      </Flex>   

    </Box>
  );


}


export default Video;